import React, {Fragment, useEffect, useRef, useState} from 'react';
import CompaniesHero from '../../Components/Companies/CompaniesHero';
import {SelectComponent, TabItem, Tabs} from '../../../shared';
import {ReactComponent as DocumentsLargeIcon} from '../../../assets/icons/documents-large-icon.svg';
import {ReactComponent as DocumentsIcon} from '../../../assets/icons/documents-icon.svg';
import {ReactComponent as DrawingIcon} from '../../../assets/icons/drawing-icon.svg';
import {ReactComponent as DrawingLargeIcon} from '../../../assets/icons/drawing-large-icon.svg';
import ProjectsItem from '../../Components/Projects/ProjectsItem';
import './CompaniesDocuments.scss';
import {useDispatch, useSelector} from 'react-redux';
import {
    addDocumentsLoading, addDrawingLoading,
    deleteCompanyDoc,
    getDocumentsCompany,
    getDrawingsCompany,
    requestApproval, resetAllCompaniesFilters, resetAllDocuments, setDocumentTab, setFilterQuery, setSearchQuery
} from '../../../redux/actions/documents/documentsActions';
import {useParams} from 'react-router-dom';
import LoadPanel from '../../Components/LoadPanel';
import NoItems from '../../Components/NoItems';
import {PERMISSIONS} from '../../../helpers/constants';
import {notifySuccess} from '../../../helpers/notifySnack';
import {hasPermission} from '../../../helpers/functions';
import {useTranslation} from 'react-i18next';
import {showConfirmPopup} from '../../../redux/actions/app/appActions';
import {getCompany} from "../../../redux/actions/company/companyActions";
import InfiniteScroll from "react-infinite-scroll-component";
import InputMUISearch from "../../../shared/InputMUISearch";

const CompaniesDocuments = () => {
    const [submitted, setSubmitted] = useState(false);
    const {singleCompany} = useSelector((state) => state.company);
    const {drawings, documents, documentTabCompany,filterQueryCompanies,searchQueryCompanies} = useSelector(({documents}) => documents);
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const {id} = useParams();
    const [documentBlock, setDocumentBlock] = useState(false);
    const [drawing, setDrawing] = useState(false);
    const [selectedBtn, setSelectedBtn] = useState(true);
    const [selectedBack, setSelectedBack] = useState(false);
    const [clicked, setClicked] = useState(false);
    const profileMe = useSelector((state) => state.profile.profileMe);
    const searchTimeoutRef = useRef(null);

    const handleDocument = () => {
        setDocumentBlock(true);
        setSelectedBtn(false);
        setDrawing(false);
        setSelectedBack(true);

    };
    const handleDrawing = () => {
        setDocumentBlock(false);
        setSelectedBtn(false);
        setDrawing(true);
        setSelectedBack(true);
    };

    const handleList = () => {
        setDocumentBlock(false);
        setSelectedBtn(true);
        setDrawing(false);
        setSelectedBack(false);
    };


    const removeHandlerSingleRedux = (documentId) => {
        dispatch(
            showConfirmPopup({
                visible: true,
                confirmCallback: () => removeHandler(documentId)
            })
        );
    };

    const removeHandler = async (documentId) => {
        if (!submitted) {
            setSubmitted(true);
            const res = await dispatch(deleteCompanyDoc(id, documentId));

            if (res.payload) {
                setSubmitted(false);
                notifySuccess(t('ProjectsDrawing.file_deleted'));
                await dispatch(getCompany(id))
            } else {
                setSubmitted(false);
            }
        }
    };


    const requestApprovalHandler = async (el) => {
        if (clicked) return;
        try {
            setClicked(true);
            const res = await dispatch(requestApproval(el.projectId, el.id));
            if (res?.payload) {
                notifySuccess(t('CompaniesDocuments.notification_sent'));

                setClicked(false);
            } else {
                setClicked(false);
            }
        } catch (e) {
            setClicked(false);
        }
    };

    const remindPermission = hasPermission(PERMISSIONS.DOCUMENT_REQUEST, profileMe?.permissions ?? []);
    const remindPermissionDrawing = hasPermission(PERMISSIONS.DRAWING_REQUEST, profileMe?.permissions ?? []);
    const downloadPermission = hasPermission(PERMISSIONS.DOCUMENT_DOWNLOAD, profileMe?.permissions ?? []);
    const permissionTrash = hasPermission(PERMISSIONS.DOCUMENT_REMOVE, profileMe?.permissions ?? []);

    const options = [
        {
            id: 'all',
            name: t('all.all')
        },
        {
            name: t('ProjectsItem.status_requested'),
            id: 'requested'
        },
        {
            name: t('ProjectsItem.status_confirm'),
            id: 'approved'
        },
        {
            name: t('ProjectsItem.status_reject'),
            id: 'rejected'
        }
    ];

    const fondOption = options?.find((option) => option.id === filterQueryCompanies);

    const fetchMore = async () => {
        await dispatch(addDocumentsLoading(id, documents.pagination.per_page, documents.pagination.current_page + 1,filterQueryCompanies,searchQueryCompanies));
    }
    const fetchMoreDrawings = async () => {
        await dispatch(addDrawingLoading(id, drawings.pagination.per_page, drawings.pagination.current_page + 1,filterQueryCompanies,searchQueryCompanies));
    }

    const handleFilterChange = (e) => {
        dispatch(setFilterQuery(e.target.value));


        // Сброс документов и загрузка с новым фильтром
        dispatch(resetAllDocuments());
        dispatch(getDocumentsCompany(id, documents.pagination.per_page, 1, e.target.value,searchQueryCompanies));
        dispatch(getDrawingsCompany(id, drawings.pagination.per_page, 1, e.target.value,searchQueryCompanies));

    };

    useEffect(() => {
        const fetchData = async () => {
            await dispatch(getDocumentsCompany(id, documents.pagination.per_page,1,filterQueryCompanies,searchQueryCompanies));
            await dispatch(getDrawingsCompany(id, drawings.pagination.per_page,1,filterQueryCompanies,searchQueryCompanies));
        };
        if (id) {
            fetchData();
        }


    }, [id]);

    useEffect(() => {
        const handleResize = () => {
            const windowWidth = window.innerWidth;
            if (windowWidth >= 1080) {
                setDocumentBlock(false);
                setSelectedBtn(true);
                setDrawing(false);
                setSelectedBack(false);
            } else {
            }
        };

        window.addEventListener('resize', handleResize);
        handleResize();

        return () => {
            dispatch(resetAllCompaniesFilters());
            window.removeEventListener('resize', handleResize)
        };
    }, []);

    const handleClear = () => {
        dispatch(setSearchQuery(''));

        dispatch(getDocumentsCompany(id, documents.pagination.per_page, 1, filterQueryCompanies, '', false));
        dispatch(getDrawingsCompany(id, drawings.pagination.per_page, 1, filterQueryCompanies, '', false));
    }
    const handleChange = (e) => {
        const value = e.target.value;

        dispatch(setSearchQuery(value));

        if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
        }

        // Set a new debonce timeout
        searchTimeoutRef.current = setTimeout(() => {
            dispatch(getDocumentsCompany(id, documents.pagination.per_page, 1, filterQueryCompanies, value, false));
            dispatch(getDrawingsCompany(id, drawings.pagination.per_page, 1, filterQueryCompanies, value, false));
        }, 500);
    };
    return (
        <div className='companies-documents'>
            <div className='companies-documents-name'>{singleCompany?.name ?? ''}</div>

            <CompaniesHero
                heading={fondOption?.name ?? ''}
                subHeading={t('CompaniesDocuments.documents')}
                handleList={handleList}
                selectedBack={selectedBack}
            />

            {!documentBlock && !drawing &&
                <Fragment>
                    <div className={'companies-documents__filter'}>
                        <div className={'companies-documents__search'}>
                            <InputMUISearch
                                className='search-box__input'
                                fullWidth
                                value={searchQueryCompanies}
                                onSearch={() => {}}
                                onClear={handleClear}
                                onChange={handleChange}
                                placeholder={t('ProjectsSearchPanel.Search')}
                            />
                        </div>
                        <SelectComponent
                            onChange={handleFilterChange}
                            disabled={drawings.loading || documents.loading}
                            value={filterQueryCompanies}
                            options={options}
                            allowClear={false}
                            fullWidth={true}
                            label={t('all.filter')}
                        />
                    </div>
                </Fragment>

            }

            {drawings.loading || documents.loading ? (
                <LoadPanel staticPos={true} circleSize={40} noBg={true}/>
            ) : (
                <>
                    {!documentBlock && !drawing ? (
                        <>
                            <div className='companies-documents__tabs'>
                                <Tabs defaultIndex='1'
                                      changeTabIndex={documentTabCompany}
                                      onTabClick={(index) => dispatch(setDocumentTab(index))}
                                >
                                    <TabItem
                                        label={t('CompaniesDocuments.documents')}
                                        icon={<DocumentsIcon/>}
                                        count={documents.pagination.total ?? null}
                                        index='1'
                                    >
                                        <div id={'scrollable'} className='companies-documents__list'>
                                            <InfiniteScroll
                                                dataLength={documents.items.length}
                                                next={fetchMore}
                                                scrollableTarget={'scrollable'}
                                                hasMore={documents.pagination.current_page < documents.pagination.last_page}
                                                loader={<LoadPanel circleSize={40} noBg={true} staticPos={true}/>}
                                            >
                                                {
                                                    documents.items.length === 0 ? (
                                                        <NoItems
                                                            description={t('CompaniesDocuments.no_documents_description')}
                                                            title={t('CompaniesDocuments.no_documents_title')}
                                                            center={'center'}
                                                        />
                                                    ) : (
                                                        <>
                                                            {documents.items.map((el) => {
                                                                return (
                                                                    <ProjectsItem
                                                                        key={el.id}
                                                                        el={el}
                                                                        id={el.id}
                                                                        remind={true}
                                                                        clear={true}
                                                                        disableRedirect={true}
                                                                        hasCheck={false}
                                                                        requestApprovalHandler={requestApprovalHandler}
                                                                        permissionDownload={downloadPermission}
                                                                        permissions={profileMe?.permissions ?? []}
                                                                        remindPermission={remindPermission}
                                                                        removeHandler={removeHandlerSingleRedux}
                                                                        permissionTrash={permissionTrash}
                                                                    />
                                                                );
                                                            })}
                                                        </>
                                                    )
                                                }
                                            </InfiniteScroll>

                                        </div>
                                    </TabItem>
                                    <TabItem
                                        label={t('CompaniesDocuments.drawings')}
                                        icon={<DrawingIcon/>}
                                        count={drawings.pagination.total ?? null}
                                        index='2'
                                    >
                                        <div id={'scrollable2'} className='companies-documents__list'>

                                            <InfiniteScroll
                                                dataLength={drawings.items.length}
                                                next={fetchMoreDrawings}
                                                scrollableTarget={'scrollable2'}
                                                hasMore={drawings.pagination.current_page < drawings.pagination.last_page}
                                                loader={<LoadPanel circleSize={40} noBg={true} staticPos={true}/>}
                                            >
                                                {drawings.items.length === 0 ? (
                                                    <NoItems
                                                        description={t('CompaniesDocuments.no_drawings_description')}
                                                        title={t('CompaniesDocuments.no_drawings_title')}
                                                        center={'center'}
                                                    />
                                                ) : (
                                                    <>
                                                        {drawings.items.map((el) => {
                                                            return (
                                                                <ProjectsItem
                                                                    key={el.id}
                                                                    el={el}
                                                                    id={el.id}
                                                                    remind={true}
                                                                    clear={true}
                                                                    disableRedirect={true}
                                                                    hasCheck={false}
                                                                    requestApprovalHandler={requestApprovalHandler}
                                                                    permissionDownload={downloadPermission}
                                                                    permissions={profileMe?.permissions ?? []}
                                                                    remindPermission={remindPermissionDrawing}
                                                                    removeHandler={removeHandlerSingleRedux}
                                                                    permissionTrash={permissionTrash}
                                                                />
                                                            );
                                                        })}
                                                    </>
                                                )}
                                            </InfiniteScroll>

                                        </div>

                                    </TabItem>
                                </Tabs>
                            </div>
                        </>
                    ) : null}

                    {selectedBtn && (
                        <div className='companies-documents__btn'>
                            <div className='btn btn-document' onClick={handleDocument}>
                                <div className='icon'>
                                    <DocumentsLargeIcon/>
                                </div>
                                <div className='info'>
                                    {t('CompaniesDocuments.documents')}
                                    <span>{documents.pagination?.total ?? 0}</span>
                                </div>
                            </div>
                            <div className='btn btn-drawing' onClick={handleDrawing}>
                                <div className='icon'>
                                    <DrawingLargeIcon/>
                                </div>
                                <div className='info'>
                                    {t('CompaniesDocuments.drawings')}
                                    <span>{drawings.pagination?.total ?? 0}</span>
                                </div>
                            </div>
                        </div>
                    )}

                    {documentBlock || drawing ? (
                        <div className={'companies-documents__filter companies-documents__filter--mob'}>
                            <SelectComponent
                                disabled={drawings.loading || documents.loading}
                                onChange={handleFilterChange}
                                value={filterQueryCompanies}
                                options={options}
                                allowClear={false}
                                fullWidth={true}
                                label={t('all.filter')}
                            />
                        </div>
                    ) : null}

                    {documentBlock && (
                        <div id={'scrollable'} className='companies-documents__list'>
                            <InfiniteScroll
                                dataLength={documents.items.length}
                                next={fetchMore}
                                scrollableTarget={'scrollable'}
                                hasMore={documents.pagination.current_page < documents.pagination.last_page}
                                loader={<LoadPanel circleSize={40} noBg={true} staticPos={true}/>}
                            >
                                {
                                    documents.items?.length === 0 ? (
                                        <NoItems
                                            description={t('CompaniesDocuments.no_documents_description')}
                                            title={t('CompaniesDocuments.no_documents_title')}
                                            center={'center'}
                                        />
                                    ) : (
                                        <>
                                            {documents.items.map((el) => {
                                                return (
                                                    <ProjectsItem
                                                        key={el.id}
                                                        el={el}
                                                        id={el.id}
                                                        remind={true}
                                                        clear={true}
                                                        disableRedirect={true}
                                                        hasCheck={false}
                                                        requestApprovalHandler={requestApprovalHandler}
                                                        permissionDownload={downloadPermission}
                                                        permissions={profileMe?.permissions ?? []}
                                                        remindPermission={remindPermission}
                                                        removeHandler={removeHandlerSingleRedux}
                                                        permissionTrash={permissionTrash}
                                                    />
                                                );
                                            })}
                                        </>
                                    )
                                }
                            </InfiniteScroll>

                        </div>
                    )}

                    {drawing && (
                        <div id={'scrollable2'} className='companies-documents__list'>

                            <InfiniteScroll
                                dataLength={drawings.items.length}
                                next={fetchMoreDrawings}
                                scrollableTarget={'scrollable2'}
                                hasMore={drawings.pagination.current_page < drawings.pagination.last_page}
                                loader={<LoadPanel circleSize={40} noBg={true} staticPos={true}/>}
                            >
                                {drawings.items.length === 0 ? (
                                    <NoItems
                                        description={t('CompaniesDocuments.no_drawings_description')}
                                        title={t('CompaniesDocuments.no_drawings_title')}
                                        center={'center'}
                                    />
                                ) : (
                                    <>
                                        {drawings.items.map((el) => {
                                            return (
                                                <ProjectsItem
                                                    key={el.id}
                                                    el={el}
                                                    id={el.id}
                                                    remind={true}
                                                    clear={true}
                                                    disableRedirect={true}
                                                    hasCheck={false}
                                                    requestApprovalHandler={requestApprovalHandler}
                                                    permissionDownload={downloadPermission}
                                                    permissions={profileMe?.permissions ?? []}
                                                    remindPermission={remindPermissionDrawing}
                                                    removeHandler={removeHandlerSingleRedux}
                                                    permissionTrash={permissionTrash}
                                                />
                                            );
                                        })}
                                    </>
                                )}
                            </InfiniteScroll>

                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default CompaniesDocuments;
